export const SAVE_MOBILE_NO = "SAVE_MOBILE_NO";
export const SAVE_CONFIG = "SAVE_CONFIG";
